import { render, staticRenderFns } from "./LicencesTable.vue?vue&type=template&id=5901e98a"
import script from "./LicencesTable.vue?vue&type=script&lang=js"
export * from "./LicencesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports